import PropTypes from 'prop-types';
// @mui
import { Box, TextField, Button } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// components
import Iconify from '../../components/Iconify';

const COLOR_BLUE = '#0275B5';
const COLOR_LIGHTBLUE = '#00A4FF';

const StyledInput = styled(TextField)(({ theme }) => ({
  width: '80%',
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: 50,
    padding: theme.spacing(0, 2),
    '& fieldset': {
      borderRadius: '10px 0 0 10px',
    },
    '&.Mui-focused fieldset': {
      borderColor: COLOR_BLUE,
    },
  },
}));

SearchBar.propTypes = {
  search: PropTypes.string,
  handleSearch: PropTypes.func,
};

export default function SearchBar({ search, handleSearch }) {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box component={'div'} sx={{ width: '100%', display: { xs: 'flex', md: 'flex' }, margin: { xs: 2, md: 0 } }}>
      <StyledInput id="search" onChange={handleSearch} placeholder="Please enter project name or keyword" />
      <Button
        variant="contained"
        // startIcon={<Iconify icon="akar-icons:search" width={1} height={1} color="inherit" />}
        sx={{
          width: { xs: '20%', md: '20%' },
          textTransform: 'none',
          backgroundColor: COLOR_BLUE,
          color: '#ffffff',
          borderRadius: '0 10px 10px 0',
          boxShadow: 0,
          fontSize: '1.1rem !important',
          '&:hover': { backgroundColor: COLOR_LIGHTBLUE },
        }}
      >
        Search
      </Button>
    </Box>
  );
}
